// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[3].oneOf[1].use[1]!../../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* antd tokens */
/* Media queries breakpoints */
/* auxiliary colors */
/* sizes */
body {
  margin: 0;
  padding: 0;
  font-family: var(--fontFamily);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f8f8f8;
  overflow-x: hidden;
  color: #656565;
}
/* scrollbar */
::-webkit-scrollbar {
  width: 2px;
  width: 0;
}
::-webkit-scrollbar {
  height: 3px;
  height: 0;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: var(--colorBorder);
}
::-webkit-scrollbar-thumb:hover {
  background: #c8c8c8;
}
* {
  outline: none !important;
}
.clickable {
  cursor: pointer;
}
/* size */
.fill-window {
  min-width: 100%;
  min-height: 100vh;
}
/* spacing */
.page-padding {
  padding: 20px;
}
@media (max-width: 768px) {
  .page-padding {
    padding: 5px;
  }
}
.section-padding {
  padding: 10px 20px;
}
.section-padding-2 {
  padding: 20px;
}
.margin-inline-end {
  margin-inline-end: 2vw;
}
.margin-inline-start {
  margin-inline-start: 2vw;
}
.margin-top {
  margin-top: 20px;
}
.margin-top-2 {
  margin-top: 40px;
}
.margin-bottom {
  margin-bottom: 10px;
}
.margin-bottom-2 {
  margin-bottom: 20px;
}
.margin-bottom-4 {
  margin-bottom: 40px;
}
.margin-vertical {
  margin: 10px 0;
}
.margin-horizontal {
  margin: 0 10px;
}
.margin-1 {
  margin: 5px;
}
.margin-2 {
  margin: 10px;
}
.no-padding {
  padding: 0 !important;
}
.no-margin {
  margin: 0 !important;
}
.width-fill {
  width: 100%;
}
.height-fill {
  height: 100%;
}
.collapse-width {
  min-width: 0 !important;
  width: 0 !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
  opacity: 0 !important;
}
/* flex */
.flex {
  display: flex;
}
.flex.column {
  flex-direction: column;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.center-content {
  align-items: center;
  justify-content: center;
}
.flex.align-end {
  align-items: flex-end;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.space-between {
  justify-content: space-between;
}
.page-fill,
.flex-fill {
  flex-grow: 1;
}
/* rounded */
.rounded-2 {
  border-radius: 2px;
}
/* border */
.border-bottom {
  border-bottom: 1px solid var(--colorBorder);
}
.border-all {
  border: 1px solid var(--colorBorder);
}
/* utils */
@media (max-width: 480px) {
  .sm-hide {
    display: none !important;
  }
}
.no-scrollbar::-webkit-scrollbar-thumb {
  background: transparent;
}
.white-background {
  background-color: white;
}
.gray-background {
  background-color: #ececec;
}
.ripple-background {
  cursor: pointer;
  display: block;
  position: relative;
  z-index: 0;
  overflow: hidden;
}
.ripple-background:before {
  content: "";
  position: absolute;
  z-index: -1;
  background: var(--colorPrimary);
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateX(-120%);
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.ripple-background:hover:before,
.ripple-background:active:before,
.ripple-background:focus:before {
  opacity: 1;
  transform: translateX(0);
}
.ripple-background:hover div,
.ripple-background:active div,
.ripple-background:focus div,
.ripple-background.persist-ripple div {
  transition: all 0.3s ease-out;
}
.ripple-background:hover div *,
.ripple-background:active div *,
.ripple-background:focus div *,
.ripple-background.persist-ripple div * {
  color: #ffffff !important;
}
.ripple-background.persist-ripple {
  background-color: var(--colorPrimary);
}
[dir="rtl"] .ripple-background:before {
  transform: translateX(120%);
}
[dir="rtl"] .ripple-background:hover:before {
  opacity: 1;
  transform: translateX(0);
}
.slide-from-side {
  animation-name: slide-from-side;
  animation-duration: 300ms;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  opacity: 0;
  transform: translateX(-20px);
}
@keyframes slide-from-side {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.slide-down {
  animation-name: slideDown;
  animation-duration: 300ms;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  opacity: 0;
  transform: translateY(-100px);
}
@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.slide-up {
  animation-name: slideUp;
  animation-duration: 300ms;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  opacity: 0;
  transform: translateY(20px);
}
@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fade-in {
  animation-name: fadeIn;
  animation-duration: 300ms;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  opacity: 0;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.animate-width {
  transition: width 300ms ease-in-out, opacity 300ms ease-in-out;
}
.primary-text {
  color: var(--colorPrimary);
  font-weight: 700;
}
.secondary-text {
  font-weight: 600;
}
.auxiliary-text {
  color: #595a59;
  font-weight: 600;
}
/* form item label */
.ant-form-item-label.ant-col-rtl {
  text-align: right;
}
.float {
  box-shadow: 0 1px 6px #00000017;
}
@media (max-width: 480px) {
  .ant-card-body {
    padding: 10px;
  }
}
.float-card {
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 1px 6px #00000017;
  background-color: white;
}
.ant-card {
  box-shadow: 0 1px 6px #00000017;
  border: unset;
}
.ant-menu-horizontal {
  background-color: transparent;
  border: none;
}
.ant-dropdown-menu {
  overflow: hidden;
}
.top-bar-menu .ant-menu-item {
  height: 40px;
  margin-inline-start: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.top-bar-menu .ant-menu-title-content {
  font-weight: 600;
  font-size: 16px;
  z-index: 1;
}
.top-bar-menu > .ant-menu-item a {
  color: #656565;
}
.top-bar-menu > .ant-menu-item:hover a {
  color: white;
}
.top-bar-menu > .ant-menu-item-selected a,
.top-bar-menu > .ant-menu-item-selected:hover a {
  color: white;
}
.top-bar-menu > .ant-menu-item::after {
  border-bottom: none !important;
  inset-inline: 0 !important;
}
.top-bar-menu > .ant-menu-item-selected:after,
.top-bar-menu > .ant-menu-item:hover:after {
  border-bottom: none !important;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  inset-inline-start: 0;
  animation-name: slide-from-side;
  animation-duration: 300ms;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
  opacity: 0;
  transform: translateX(-20px);
}
@keyframes slide-from-side {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.top-bar-menu > .ant-menu-item:hover:after {
  background-color: var(--colorPrimary);
}
.top-bar-menu > .ant-menu-item-selected:after {
  background-color: var(--colorSecondary) !important;
}
.top-bar-menu > .ant-menu-item a:hover {
  color: white;
}
.top-bar-menu .anticon {
  font-size: 18px !important;
  transition: none !important;
}
.top-bar-menu > .ant-menu-submenu-horizontal {
  color: #c8c8c8 !important;
}
.tags {
  display: flex;
  flex-wrap: wrap;
}
.tag {
  margin-top: 8px;
  border: 1px solid #d9d9d9;
  padding: 2px 10px;
  border-radius: 30px;
}
.ant-table-content {
  overflow: auto;
}
.ant-collapse {
  background: white;
  box-shadow: 0 1px 6px #00000017;
  border: unset;
}
.ant-collapse .ant-collapse {
  box-shadow: unset;
}
.ant-collapse.height-nested .ant-collapse {
  border: calc(var(--lineWidth) * 1px) solid rgba(0, 0, 0, 0.05);
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  align-items: center;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
  padding-inline-end: 0;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-content,
.ant-collapse > .ant-collapse-item {
  border-color: rgba(0, 0, 0, 0.05);
}
.no-padding-collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding: 0 !important;
}
.no-border-collapse .ant-collapse-borderless > .ant-collapse-item {
  border-bottom: unset;
}
.no-padding-collapse-header > .ant-collapse-item > .ant-collapse-header {
  padding: 0 !important;
}
.highlight-collapse-header-hover > .ant-collapse-item > .ant-collapse-header:hover {
  background-color: var(--colorBorder);
}
.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  padding-right: 16px;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  margin: 6px 16px;
  right: 0;
  position: absolute;
}
.ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: var(--colorSecondary);
}
.ant-menu-light .ant-menu-item-selected {
  color: var(--colorSecondary);
  background-color: var(--colorSecondaryLight);
}
.ant-menu-light.ant-menu-inline .ant-menu-sub.ant-menu-inline {
  background: unset;
}
[dir="rtl"] .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  left: 0;
  margin: 0 16px;
  right: unset;
}
[dir="rtl"] .ant-collapse-rtl .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding-right: 16px;
}
.popover-no-padding .ant-popover-inner {
  padding: 0 !important;
}
[dir="rtl"] .ant-input-group > .ant-input:last-child,
[dir="rtl"] .ant-input-group-addon:last-child {
  border-top-left-radius: calc(var(--borderRadius) * 1px);
  border-bottom-left-radius: calc(var(--borderRadius) * 1px);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-wrapper {
  padding: 6px 10px;
  font-size: var(--fontSizeLG);
  line-height: var(--lineHeightLG);
  border-radius: calc(var(--borderRadiusLG) * 1px);
  border-width: calc(var(--lineWidth) * 1px);
  border-color: var(--colorBorder);
  border-style: solid;
}
.input-wrapper:hover {
  border-color: var(--colorPrimaryHover);
}
.input-wrapper:active,
.input-wrapper:focus {
  border-color: var(--colorPrimaryActive);
}
.ant-input-wrapper .ant-btn-icon {
  align-items: center;
  justify-content: center;
  display: flex;
}
.ant-message .ant-message-custom-content {
  font-family: var(--fontFamily);
}
.compact-options .ant-select-item {
  padding: 5px !important;
}
.compact-options .ant-select-selection-item {
  padding: 0 !important;
}
.ant-space.width-fill > .ant-space-item {
  width: 100%;
}
.ant-btn-icon {
  height: 100%;
}
.tab-bar .ant-tabs-nav-list {
  width: 99%;
}
.tab-bar .ant-tabs-tab {
  padding: 15px !important;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.tab-bar [role="tablist"] {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/theme/index.less","webpack://./src/theme/global.less","webpack://./src/theme/layout.less","webpack://./src/theme/colors.less","webpack://./src/theme/animations.less","webpack://./src/theme/text.less","webpack://./src/theme/card.less","webpack://./src/theme/menu.less","webpack://./src/theme/tags.less","webpack://./src/theme/table.less","webpack://./src/theme/collapsable.less","webpack://./src/theme/popover.less","webpack://./src/theme/input.less","webpack://./src/theme/message.less","webpack://./src/theme/select.less","webpack://./src/theme/space.less","webpack://./src/theme/button.less","webpack://./src/theme/tabs.less"],"names":[],"mappings":"AACA,gBAAgB;AAChB,8BAA8B;AAC9B,qBAAqB;AACrB,UAAU;ACFV;EACE,SAAA;EACA,UAAA;EACA,8BAAA;EACA,mCAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;ADIF;AACA,cAAc;ACAd;EACE,UAAA;EACA,QAAA;ADEF;ACCA;EACE,WAAA;EACA,SAAA;ADCF;ACEA;EACE,uBAAA;ADAF;ACGA;EACE,8BAAA;ADDF;ACIA;EACE,mBAAA;ADFF;ACKA;EACE,wBAAA;ADHF;ACMA;EACE,eAAA;ADJF;AACA,SAAS;AEnCT;EACE,eAAA;EACA,iBAAA;AFqCF;AACA,YAAY;AEjCZ;EACE,aAAA;AFmCF;AEjCE;EAAA;IACE,YAAA;EFoCF;AACF;AEjCA;EACE,kBAAA;AFmCF;AEhCA;EACE,aAAA;AFkCF;AE/BA;EACE,sBAAA;AFiCF;AE9BA;EACE,wBAAA;AFgCF;AE7BA;EACE,gBAAA;AF+BF;AE5BA;EACE,gBAAA;AF8BF;AE3BA;EACE,mBAAA;AF6BF;AE1BA;EACE,mBAAA;AF4BF;AEzBA;EACE,mBAAA;AF2BF;AExBA;EACE,cAAA;AF0BF;AEvBA;EACE,cAAA;AFyBF;AEtBA;EACE,WAAA;AFwBF;AErBA;EACE,YAAA;AFuBF;AEpBA;EACE,qBAAA;AFsBF;AEnBA;EACE,oBAAA;AFqBF;AElBA;EACE,WAAA;AFoBF;AEjBA;EACE,YAAA;AFmBF;AEhBA;EACE,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,qBAAA;AFkBF;AACA,SAAS;AEdT;EACE,aAAA;AFgBF;AEdE;EACE,sBAAA;AFgBJ;AEbE;EACE,eAAA;AFeJ;AEZE;EACE,mBAAA;EACA,uBAAA;AFcJ;AEXE;EACE,qBAAA;AFaJ;AEVE;EACE,yBAAA;AFYJ;AETE;EACE,8BAAA;AFWJ;AEPA;;EACE,YAAA;AFUF;AACA,YAAY;AEJZ;EACE,kBAAA;AFMF;AACA,WAAW;AEFX;EACE,2CAAA;AFIF;AEDA;EACE,oCAAA;AFGF;AACA,UAAU;AEGR;EAAA;IACE,wBAAA;EFAF;AACF;AEIE;EACE,uBAAA;AFFJ;AG7JA;EACE,uBAAA;AH+JF;AG5JA;EACE,yBAAA;AH8JF;AInKA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AJqKF;AInKE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,oDAAA;AJqKJ;AIlKE;;;EACE,UAAA;EACA,wBAAA;AJsKJ;AInKE;;;;EAEI,6BAAA;AJuKN;AIzKE;;;;EAIM,yBAAA;AJ2KR;AItKE;EACE,qCAAA;AJwKJ;AInKE;EACE,2BAAA;AJqKJ;AIlKE;EACE,UAAA;EACA,wBAAA;AJoKJ;AIhKA;EACE,+BAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,UAAA;EACA,4BAAA;AJkKF;AIhKE;EACE;IACE,UAAA;IACA,4BAAA;EJkKJ;EIhKE;IACE,UAAA;IACA,wBAAA;EJkKJ;AACF;AI9JA;EACE,yBAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,UAAA;EACA,6BAAA;AJgKF;AI9JE;EACE;IACE,UAAA;IACA,6BAAA;EJgKJ;EI9JE;IACE,UAAA;IACA,wBAAA;EJgKJ;AACF;AI5JA;EACE,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,UAAA;EACA,2BAAA;AJ8JF;AI5JE;EACE;IACE,UAAA;IACA,2BAAA;EJ8JJ;EI5JE;IACE,UAAA;IACA,wBAAA;EJ8JJ;AACF;AI1JA;EACE,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,UAAA;AJ4JF;AI1JE;EACE;IACE,UAAA;EJ4JJ;EI1JE;IACE,UAAA;EJ4JJ;AACF;AIxJA;EACE,8DAAA;AJ0JF;AKzRA;EACE,0BAAA;EACA,gBAAA;AL2RF;AKxRA;EACE,gBAAA;AL0RF;AKvRA;EACE,cAAA;EACA,gBAAA;ALyRF;AACA,oBAAoB;AKtRpB;EACE,iBAAA;ALwRF;AMxSA;EACE,+BAAA;AN0SF;AMvSA;EACE;IACE,aAAA;ENySF;AACF;AMtSA;EACE,aAAA;EACA,kBAAA;EACA,+BAAA;EACA,uBAAA;ANwSF;AMrSA;EACE,+BAAA;EACA,aAAA;ANuSF;AO1TA;EACE,6BAAA;EACA,YAAA;AP4TF;AOzTA;EACE,gBAAA;AP2TF;AOxTA;EAEI,YAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;APyTJ;AO/TA;EAUI,gBAAA;EACA,eAAA;EACA,UAAA;APwTJ;AOrTE;EACE,cAAA;APuTJ;AOpTE;EAGI,YAAA;APoTN;AOhTE;;EAII,YAAA;APgTN;AO5SE;EACE,8BAAA;EACA,0BAAA;AP8SJ;AO3SE;;EAGE,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EAEA,+BAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,UAAA;EACA,4BAAA;AP2SJ;AOzSI;EACE;IACE,UAAA;IACA,4BAAA;EP2SN;EOzSI;IACE,UAAA;IACA,wBAAA;EP2SN;AACF;AOvSE;EAEE,qCAAA;APwSJ;AOrSE;EAEE,kDAAA;APsSJ;AOnSE;EACE,YAAA;APqSJ;AOlSE;EACE,0BAAA;EACA,2BAAA;APoSJ;AOjSE;EACE,yBAAA;APmSJ;AQrYA;EACE,aAAA;EACA,eAAA;ARuYF;AQpYA;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;ARsYF;AS/YA;EACE,cAAA;ATiZF;AUhZA;EACE,iBAAA;EACA,+BAAA;EACA,aAAA;AVkZF;AUrZA;EAMI,iBAAA;AVkZJ;AU/YE;EACE,8DAAA;AViZJ;AU9YE;EACE,mBAAA;AVgZJ;AU7YE;EACE,qBAAA;AV+YJ;AU5YE;;EACE,iCAAA;AV+YJ;AU1YE;EACE,qBAAA;AV4YJ;AUxYA;EAEI,oBAAA;AVyYJ;AUpYE;EACE,qBAAA;AVsYJ;AUjYE;EACE,oCAAA;AVmYJ;AU/XA;EACE,mBAAA;AViYF;AU9XA;EACE,gBAAA;EACA,QAAA;EACA,kBAAA;AVgYF;AU7XA;EACE,4BAAA;AV+XF;AU5XA;EACE,4BAAA;EACA,4CAAA;AV8XF;AU3XA;EACE,iBAAA;AV6XF;AU1XA;EAEI,OAAA;EACA,cAAA;EACA,YAAA;AV2XJ;AU/XA;EAQI,mBAAA;AV0XJ;AW3cA;EAEI,qBAAA;AX4cJ;AY9cA;;EAEI,uDAAA;EACA,0DAAA;EACA,0BAAA;EACA,6BAAA;AZgdJ;AY5cA;EACE,iBAAA;EACA,4BAAA;EACA,gCAAA;EACA,gDAAA;EACA,0CAAA;EACA,gCAAA;EACA,mBAAA;AZ8cF;AY5cE;EACE,sCAAA;AZ8cJ;AY3cE;;EACE,uCAAA;AZ8cJ;AY1cA;EAEI,mBAAA;EACA,uBAAA;EACA,aAAA;AZ2cJ;Aa1eA;EACE,8BAAA;Ab4eF;Ac7eA;EAEI,uBAAA;Ad8eJ;AchfA;EAMI,qBAAA;Ad6eJ;AejfI;EACE,WAAA;AfmfN;AgBxfA;EACE,YAAA;AhB0fF;AiB3fA;EAGG,UAAA;AjB2fH;AiB9fA;EAOI,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AjB0fJ;AiBpgBA;EAcI,gBAAA;AjByfJ","sourcesContent":["@import '~antd/dist/reset.css';\n@import 'variable';\n@import 'global';\n@import 'layout';\n@import 'colors';\n@import 'animations';\n@import 'text';\n@import 'card';\n@import 'menu';\n@import 'tags';\n@import 'table';\n@import 'collapsable';\n@import 'popover';\n@import 'input';\n@import 'message';\n@import 'select';\n@import 'space';\n@import 'button';\n@import 'tabs';\n","@import 'variable';\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: @font-family;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: @color-background;\n  overflow-x: hidden;\n  color: @color-text;\n}\n\n/* scrollbar */\n\n::-webkit-scrollbar {\n  width: 2px;\n  width: 0; // todo\n}\n\n::-webkit-scrollbar {\n  height: 3px;\n  height: 0; // todo\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: @color-border;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: @color-dim-text;\n}\n\n*{\n  outline: none !important;\n}\n\n.clickable{\n  cursor: pointer;\n}\n\n\n","@import 'variable';\n\n/* size */\n\n.fill-window{\n  min-width: 100%;\n  min-height: 100vh;\n}\n\n/* spacing */\n\n.page-padding{\n  padding: @page-padding;\n\n  @media (max-width: @screen-md) {\n    padding: @page-padding-mobile;\n  }\n}\n\n.section-padding{\n  padding: 10px 20px;\n}\n\n.section-padding-2{\n  padding: 20px;\n}\n\n.margin-inline-end{\n  margin-inline-end: 2vw;\n}\n\n.margin-inline-start{\n  margin-inline-start: 2vw;\n}\n\n.margin-top{\n  margin-top: 20px;\n}\n\n.margin-top-2{\n  margin-top: 40px;\n}\n\n.margin-bottom{\n  margin-bottom: 10px;\n}\n\n.margin-bottom-2{\n  margin-bottom: 20px;\n}\n\n.margin-bottom-4{\n  margin-bottom: 40px;\n}\n\n.margin-vertical{\n  margin: 10px 0;\n}\n\n.margin-horizontal{\n  margin: 0 10px;\n}\n\n.margin-1{\n  margin: 5px;\n}\n\n.margin-2{\n  margin: 10px;\n}\n\n.no-padding{\n  padding: 0 !important;\n}\n\n.no-margin{\n  margin: 0 !important;\n}\n\n.width-fill{\n  width: 100%;\n}\n\n.height-fill{\n  height: 100%;\n}\n\n.collapse-width{\n  min-width: 0 !important;\n  width: 0 !important;\n  border: none !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  overflow: hidden !important;\n  opacity: 0 !important;\n}\n\n/* flex */\n\n.flex{\n  display: flex;\n\n  &.column{\n    flex-direction: column;\n  }\n\n  &.wrap{\n    flex-wrap: wrap;\n  }\n\n  &.center-content{\n    align-items: center;\n    justify-content: center;\n  }\n\n  &.align-end{\n    align-items: flex-end;\n  }\n\n  &.justify-end{\n    justify-content: flex-end;\n  }\n\n  &.space-between{\n    justify-content: space-between;\n  }\n}\n\n.page-fill, .flex-fill{\n  flex-grow: 1;\n}\n\n\n\n/* rounded */\n\n.rounded-2 {\n  border-radius: 2px;\n}\n\n/* border */\n\n.border-bottom {\n  border-bottom: 1px solid @color-border;\n}\n\n.border-all {\n  border: 1px solid @color-border;\n}\n\n\n/* utils */\n\n.sm-hide{\n  @media (max-width: @screen-xs) {\n    display: none !important;\n  }\n}\n\n.no-scrollbar{\n  &::-webkit-scrollbar-thumb {\n    background: transparent;\n  }\n}\n","@import 'variable';\n\n.white-background{\n  background-color: white;\n}\n\n.gray-background{\n  background-color: #ececec;\n}\n","@import 'variable';\n\n.ripple-background {\n  cursor: pointer;\n  display: block;\n  position: relative;\n  z-index: 0;\n  overflow: hidden;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    background: @color-primary;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    transform: translateX(-120%);\n    transition: transform 0.25s ease, opacity 0.25s ease;\n  }\n\n  &:hover:before, &:active:before, &:focus:before {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  &:hover, &:active, &:focus, &.persist-ripple {\n    div {\n      transition: all 0.3s ease-out;\n      * {\n        color: #ffffff !important;\n      }\n    }\n  }\n\n  &.persist-ripple{\n    background-color: @color-primary;\n  }\n}\n\n[dir=\"rtl\"] .ripple-background {\n  &:before {\n    transform: translateX(120%);\n  }\n\n  &:hover:before {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.slide-from-side {\n  animation-name: slide-from-side;\n  animation-duration: 300ms;\n  animation-timing-function: ease;\n  animation-fill-mode: forwards;\n  opacity: 0;\n  transform: translateX(-20px);\n\n  @keyframes slide-from-side {\n    0% {\n      opacity: 0;\n      transform: translateX(-20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n}\n\n.slide-down {\n  animation-name: slideDown;\n  animation-duration: 300ms;\n  animation-timing-function: ease;\n  animation-fill-mode: forwards;\n  opacity: 0;\n  transform: translateY(-100px);\n\n  @keyframes slideDown {\n    0% {\n      opacity: 0;\n      transform: translateY(-100px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n}\n\n.slide-up {\n  animation-name: slideUp;\n  animation-duration: 300ms;\n  animation-timing-function: ease;\n  animation-fill-mode: forwards;\n  opacity: 0;\n  transform: translateY(20px);\n\n  @keyframes slideUp {\n    0% {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n}\n\n.fade-in {\n  animation-name: fadeIn;\n  animation-duration: 300ms;\n  animation-timing-function: ease;\n  animation-fill-mode: forwards;\n  opacity: 0;\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n}\n\n.animate-width{\n  transition: width 300ms ease-in-out, opacity 300ms ease-in-out;\n}\n\n\n","@import 'variable';\n\n.primary-text{\n  color: @color-primary;\n  font-weight: 700;\n}\n\n.secondary-text{\n  font-weight: 600;\n}\n\n.auxiliary-text{\n  color: #595a59;\n  font-weight: 600;\n}\n\n/* form item label */\n.ant-form-item-label.ant-col-rtl {\n  text-align: right;\n}\n","@import 'variable';\n\n.float {\n  box-shadow: @float-shadow\n}\n\n@media (max-width: @screen-xs) {\n  .ant-card-body {\n    padding: 10px;\n  }\n}\n\n.float-card {\n  padding: 20px;\n  border-radius: 2px;\n  box-shadow: @float-shadow;\n  background-color: white;\n}\n\n.ant-card{\n  box-shadow: @float-shadow;\n  border: unset;\n}\n","@import 'variable';\n\n.ant-menu-horizontal {\n  background-color: transparent;\n  border: none;\n}\n\n.ant-dropdown-menu{\n  overflow: hidden;\n}\n\n.top-bar-menu {\n  .ant-menu-item{\n    height: 40px;\n    margin-inline-start: 4px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .ant-menu-title-content {\n    font-weight: 600;\n    font-size: 16px;\n    z-index: 1;\n  }\n\n  & > .ant-menu-item a {\n    color: @color-text;\n  }\n\n  & > .ant-menu-item:hover\n  {\n    a {\n      color: white;\n    }\n  }\n\n  & > .ant-menu-item-selected,\n  & > .ant-menu-item-selected:hover\n  {\n    a {\n      color: white;\n    }\n  }\n\n  & > .ant-menu-item::after {\n    border-bottom: none !important;\n    inset-inline: 0 !important;\n  }\n\n  & > .ant-menu-item-selected:after,\n  & > .ant-menu-item:hover:after\n  {\n    border-bottom: none !important;\n    border-radius: 10px;\n    height: 100%;\n    width: 100%;\n    inset-inline-start: 0;\n\n    animation-name: slide-from-side;\n    animation-duration: 300ms;\n    animation-timing-function: ease;\n    animation-fill-mode: forwards;\n    opacity: 0;\n    transform: translateX(-20px);\n\n    @keyframes slide-from-side {\n      0% {\n        opacity: 0;\n        transform: translateX(-20px);\n      }\n      100% {\n        opacity: 1;\n        transform: translateX(0);\n      }\n    }\n  }\n\n  & > .ant-menu-item:hover:after\n  {\n    background-color: @color-primary;\n  }\n\n  & > .ant-menu-item-selected:after\n  {\n    background-color: @color-secondary !important;\n  }\n\n  & > .ant-menu-item a:hover{\n    color: white;\n  }\n\n  &  .anticon{\n    font-size: 18px !important;\n    transition: none !important;\n  }\n\n  & > .ant-menu-submenu-horizontal {\n    color: @color-dim-text !important;\n  }\n}\n",".tags{\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.tag{\n  margin-top: 8px;\n  border: 1px solid #d9d9d9;\n  padding: 2px 10px;\n  border-radius: 30px;\n}\n",".ant-table-content {\n  overflow: auto;\n}\n","@import 'variable';\n\n.ant-collapse{\n  background: white;\n  box-shadow: @float-shadow;\n  border: unset;\n\n  .ant-collapse{\n    box-shadow: unset;\n  }\n\n  &.height-nested .ant-collapse{\n    border: @line-width solid @color-shadow-light;\n  }\n\n  & >.ant-collapse-item >.ant-collapse-header{\n    align-items: center;\n  }\n\n  & >.ant-collapse-item >.ant-collapse-header .ant-collapse-expand-icon{\n    padding-inline-end: 0;\n  }\n\n  & > .ant-collapse-item > .ant-collapse-content, & > .ant-collapse-item {\n    border-color: @color-shadow-light;\n  }\n}\n\n.no-padding-collapse{\n  & > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box{\n    padding: 0 !important;\n  }\n}\n\n.no-border-collapse{\n  .ant-collapse-borderless > .ant-collapse-item {\n    border-bottom: unset;\n  }\n}\n\n.no-padding-collapse-header{\n  & > .ant-collapse-item > .ant-collapse-header{\n    padding: 0 !important;\n  }\n}\n\n.highlight-collapse-header-hover{\n  & > .ant-collapse-item > .ant-collapse-header:hover{\n    background-color: @color-border;\n  }\n}\n\n.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header{\n  padding-right: 16px;\n}\n\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow{\n  margin: 6px 16px;\n  right: 0;\n  position: absolute;\n}\n\n.ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title{\n  color: @color-secondary;\n}\n\n.ant-menu-light .ant-menu-item-selected{\n  color: @color-secondary;\n  background-color: @color-secondary-light;\n}\n\n.ant-menu-light.ant-menu-inline .ant-menu-sub.ant-menu-inline{\n  background: unset;\n}\n\n[dir=\"rtl\"]{\n  .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow{\n    left: 0;\n    margin: 0 16px;\n    right: unset;\n  }\n\n  .ant-collapse-rtl .ant-collapse > .ant-collapse-item > .ant-collapse-header{\n    padding-right: 16px;\n  }\n}\n\n\n","@import 'variable';\n\n.popover-no-padding{\n  .ant-popover-inner{\n    padding: 0 !important;\n  }\n}\n","@import 'variable';\n\n[dir=\"rtl\"]{\n  .ant-input-group > .ant-input:last-child, .ant-input-group-addon:last-child{\n    border-top-left-radius: @border-radius;\n    border-bottom-left-radius: @border-radius;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n}\n\n.input-wrapper{\n  padding: 6px 10px;\n  font-size: @font-size-l-g;\n  line-height: @line-height-l-g;\n  border-radius: @border-radius-l-g;\n  border-width: @line-width;\n  border-color: @color-border;\n  border-style: solid;\n\n  &:hover{\n    border-color: @color-primary-hover;\n  }\n\n  &:active, &:focus{\n    border-color: @color-primary-active;\n  }\n}\n\n.ant-input-wrapper{\n  .ant-btn-icon {\n    align-items: center;\n    justify-content: center;\n    display: flex;\n  }\n}\n\n\n","@import 'variable';\n\n.ant-message .ant-message-custom-content{\n  font-family: @font-family;\n}\n\n","@import 'variable';\n\n.compact-options{\n  .ant-select-item{\n    padding: 5px !important;\n  }\n\n  .ant-select-selection-item {\n    padding: 0 !important;\n  }\n}\n","@import 'variable';\n\n.ant-space{\n  &.width-fill{\n    & > .ant-space-item{\n      width: 100%;\n    }\n  }\n}\n",".ant-btn-icon {\n  height: 100%;\n}\n",".tab-bar{\n\n  .ant-tabs-nav-list {\n   width: 99%;\n  }\n\n  .ant-tabs-tab {\n    padding: 15px !important;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n  }\n\n  [role=\"tablist\"]{\n    margin-bottom: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
